import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';
import { FontBoxField as EditComponent } from '../tsx/FontBoxField';

export class FontBoxField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(glob, title: string, validators?: any, defaultVal: any = {}, options?, directionOptions?) {
        super(glob, title, FontBoxField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
